// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/3d-printing/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const p3dPrintingEN: PageEntry = {
  id: "post.3d-druck",
  locale: "en",
  slug: "3d-printing",
  seo: {
    title: "Glossary: 3D printing explained simply | Dietz GmbH",
    description: "3D printing, also known as additive manufacturing, is a manufacturing process in which three-dimensional objects are built up layer by layer. This is done by depositing materials s",
  },
  type: "post",
  h1: "Glossary: 3D printing explained simply",
  intro: "3D printing, also known as additive manufacturing, is a manufacturing process in which three-dimensional objects are built up layer by layer. This is done by depositing materials such as plastics, metals or ceramics. 3D printing enables the production of complex structures and prototypes with high precision. This process is used in various industries, from the manufacture of prototypes to the production of customised components. The technology has developed rapidly in recent years and plays a crucial role in the modern manufacturing industry.",
  blocks: [

  ],
};
